import { useQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';

import { ApiCategoriesResponse } from '../lib/api/Taxonomies';

import { useApi } from '../contexts/ApiContext';

type UseCategoriesOptions = Omit<
    Parameters<typeof useQuery<ApiCategoriesResponse>>[0],
    'queryKey' | 'queryFn'
> & {
    keepPreviousData?: boolean;
};

export default function useCategories(query = null, opts: UseCategoriesOptions = null) {
    const api = useApi();
    const { keepPreviousData = true } = opts || {};
    const { data = null, ...queryResult } = useQuery({
        queryKey: ['categories', query],
        queryFn: ({ queryKey: [, queryParam], signal }) =>
            api.taxonomies.categories(queryParam, null, null, { signal }),
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...opts,
    });

    const { data: items, pagination } = data || {};

    return {
        items,
        pagination,
        ...queryResult,
    };
}
